import { createAsyncAction, createAction } from "typesafe-actions";

import {
  ChatListResponse,
  ChatMessage,
  ChatStarter,
  ChatsFilter,
  IChat,
  IDeleteChatSuccess,
  IReactToMessageDto,
  IUpdateChatDto,
  TokenQuota,
} from "../interfaces";
import { ChatActionTypes } from "./constants";

export const getChatList = createAsyncAction(
  ChatActionTypes.GET_CHAT_LIST,
  ChatActionTypes.GET_CHAT_LIST_SUCCESS,
  ChatActionTypes.GET_CHAT_LIST_FAILURE,
)<ChatsFilter, ChatListResponse, Error>();

export const getChat = createAsyncAction(
  ChatActionTypes.GET_CHAT,
  ChatActionTypes.GET_CHAT_SUCCESS,
  ChatActionTypes.GET_CHAT_FAILURE,
)<string, IChat | null, Error>(); // payload = chat uuid

export const updateChat = createAsyncAction(
  ChatActionTypes.UPDATE_CHAT,
  ChatActionTypes.UPDATE_CHAT_SUCCESS,
  ChatActionTypes.UPDATE_CHAT_FAILURE,
)<IUpdateChatDto, IChat, Error>();

export const deleteChat = createAsyncAction(
  ChatActionTypes.DELETE_CHAT,
  ChatActionTypes.DELETE_CHAT_SUCCESS,
  ChatActionTypes.DELETE_CHAT_FAILURE,
)<string, IDeleteChatSuccess, Error>(); // payload = chat uuid

export const reactToMessage = createAsyncAction(
  ChatActionTypes.REACT_TO_MESSAGE,
  ChatActionTypes.REACT_TO_MESSAGE_SUCCESS,
  ChatActionTypes.REACT_TO_MESSAGE_FAILURE,
)<IReactToMessageDto, ChatMessage, Error>();

export const getStarters = createAsyncAction(
  ChatActionTypes.GET_STARTERS,
  ChatActionTypes.GET_STARTERS_SUCCESS,
  ChatActionTypes.GET_STARTERS_FAILURE,
)<void, ChatStarter[], Error>();

export const getQuota = createAsyncAction(
  ChatActionTypes.GET_QUOTA,
  ChatActionTypes.GET_QUOTA_SUCCESS,
  ChatActionTypes.GET_QUOTA_FAILURE,
)<void, { quota: TokenQuota | null }, Error>();

export const setFilter = createAction(ChatActionTypes.SET_FILTER)<ChatsFilter | null>();
export const clearChat = createAction(ChatActionTypes.CLEAR_CHAT)();
export const clearChats = createAction(ChatActionTypes.CLEAR_CHATS)();
